module.exports = __webpack_public_path__ + "static/2-19218b69469d02a286991cd66891c324.jpg";